import React, { VFC } from 'react';
import styled, { css } from 'styled-components';

interface Props extends React.HTMLProps<HTMLDivElement> {
  spacing?: number;
  horizontal?: boolean;
}
const StyledSpacer = styled.div<Props>`
  height: ${({ spacing }) => spacing && (spacing * 8) / 10}rem;
  ${({ horizontal, spacing }) =>
    horizontal &&
    css`
      width: ${spacing && (spacing * 8) / 10}rem;
      height: 0px;
    `};
`;

const Spacing: VFC<Props> = ({ horizontal, spacing = 1 }) => (
  <StyledSpacer horizontal={horizontal} spacing={spacing} />
);

export default Spacing;
